<template>
        <div  class="services-card card col-12 p-0" :class="activeCheck" v-if="servicesLoaded">
          <div class="row container-fluid services-card-row">
            <div v-if='statusCheck() && service.status == 0' class="col-xl-1 col-3 servicetype rounded-topleft rounded-bottomleft" v-bind:class="'bg-luminous'">
              <div class="content text-center">{{ serviceDescription() }}</div> <!--If Service is disabled-->
            </div>
            <div v-else-if='statusCheck() && service.status == 2' class="col-xl-1 col-3 servicetype rounded-topleft rounded-bottomleft" v-bind:class="'bg-planning'">
              <div class="content text-center">{{ serviceDescription() }}</div> <!--If Service is planned but not active yet-->
            </div>
            <div class="col-xl-1 col-3  servicetype rounded-topleft rounded-bottomleft" v-bind:class="'bg-warning'" v-else-if="serviceStatus.state === 1 && !showColour">
              <div class="content text-center">{{ serviceDescription() }}</div>
            </div>
            <div class="col-xl-1 col-3 servicetype rounded-topleft rounded-bottomleft" v-bind:class="'bg-info'" v-else-if="serviceStatus.state === 2 && !showColour">
              <div class="content text-center">{{ serviceDescription() }}</div>
            </div>
            <div class="col-xl-1 col-3 servicetype rounded-topleft rounded-bottomleft" v-bind:class="'bg-danger'" v-else-if="serviceStatus.state === 3 && !showColour">
              <div class="content text-center">{{ serviceDescription() }}</div>
            </div>
            <div class="col-xl-1 col-3 servicetype rounded-topleft rounded-bottomleft" v-bind:class="'bg-'+servicetype(service.type).color" v-else>
              <div class="content text-center">{{ serviceDescription() }}</div>
            </div>

            <router-link :to="'/service/'+service.serviceid" style="max-width:28%"  class="services-card-link col-6 col-md-6 col-lg-4 col-xl-4 serviceid p-2">
              <div class="content pl-xl-2">
                <h4 class="text-muted">{{ service.serviceid }}</h4>
                <div class="text-muted">{{ serviceDescription() }}</div>
              </div>
            </router-link>


            <router-link  v-if="validSite(service.aendsiteid)"  :to="'/site/'+service.aendsiteid" class="col-2 site d-none  d-xl-inline services-card-link">
              <div class="row sitenumber">
                <h4 class="text-muted">{{ service.aendsitenumber }}</h4>
              </div>
              <div class="row sitename text-muted">{{ service.aendsitename }}</div>
            </router-link>
            <div v-else   class="col-2 site d-none d-xl-inline">
              <div class="row sitenumber">
                <h4 class="text-muted">{{ service.aendsitenumber }}</h4>
              </div>
              <div class="row sitename text-muted">{{ service.aendsitename }}</div>
            </div>


            
            
            <router-link :to="'/vpls/'+service.bendsiteid" v-if="(service.type == 'F' || service.type == 'W') && validSite(service.bendsiteid)" class="col-2 site d-none d-xl-inline services-card-link">
              <div class="row sitenumber">
                <h4 class="text-muted">{{ service.bendsitenumber }}</h4>
              </div>
              <div class="row sitename text-muted">{{ service.bendsitename }}</div>
            </router-link>
            <router-link :to="'/site/'+service.bendsiteid" v-else-if="validSite(service.bendsiteid)" class="col-2  site  d-none d-xl-inline services-card-link">
              <div class="row sitenumber">
                <h4 class="text-muted">{{ service.bendsitenumber }}</h4>
              </div>
              <div class="row sitename text-muted">{{ service.bendsitename }}</div>
            </router-link>
            <div v-else class="col-2 site  d-none d-xl-inline">
              <div class="row sitenumber">
                <h4 class="text-muted">{{ service.bendsitenumber }}</h4>
              </div>
              <div class="row sitename text-muted">{{ service.bendsitename }}</div>
            </div>

            <router-link :to="'/event/'+serviceStatus.events[0].eventid" class=" col-3 col-lg-4 col-xl-3 services-card-link site container-fluid d-none d-lg-inline d-xl-inline" v-if="serviceStatus.state > 0">
              <div class="row sitenumber">
                <h4 class="text-muted">Status:
                  <span class="text-planning" v-if="service.status == 0">
                    Disabled
                  </span>
                  <span class="text-planning" v-if="service.status == 2">
                    Planned
                  </span>
                  <span class="text-warning" v-else-if="serviceStatus.state == 1">
                    Maintenance
                  </span>
                  <span class="text-info" v-else-if="serviceStatus.state == 2">
                    At-Risk
                  </span>
                  <span class="text-danger" v-else-if="serviceStatus.state == 3">
                    Offline
                  </span>

                </h4>
              </div>
              <div class="row sitename text-warning" v-if="serviceStatus.state == 1">
                Undergoing Scheduled Works #{{ serviceStatus.events[0].number }}
              </div>
              <div class="row sitename text-info" v-else-if="serviceStatus.state == 2">
                Within Hazard Window #{{ serviceStatus.events[0].number }}
              </div>
              <div class="row sitename text-danger" v-else-if="serviceStatus.state == 3">
                Affected by Network Outage #{{ serviceStatus.events[0].number }}
              </div>
            </router-link>
             <div class="col-3 site container-fluid d-none d-xl-inline" v-else-if="statusCheck() && service.status == 2">
              <div class="row sitenumber">
                <h4 class="text-muted pb-3">Status:
                  <span class="text-planning pb-2">
                    Planned
                  </span>
                </h4>
              </div> 
              <div class="row sitename text-planning" > <!--Check if service.status exists first for VERNet users as Customers don't see disabled services-->
                Service is being provisioned for Customer
              </div>

            </div>

            <div class="col-3 site container-fluid d-none d-xl-inline" v-else-if="service.type == 'A' || service.type == 'Q' || service.type == 'Z'">
              <div class="row sitenumber">
                <h4 class="text-muted pb-3">Status:
                  <span class="text-success pb-2">
                    Available
                  </span>
                </h4>
              </div> 
              <div class="row sitename text-luminous" v-if = "statusCheck() && service.status == 0"> <!--Check if service.status exists first for VERNet users as Customers don't see disabled services-->
              Disabled
              </div>
              <div class="row sitename text-planning" v-else>
                Monitoring is not provided for unmanaged services
              </div>
            </div>

            <div class="col-3 col-lg-5 col-xl-3  site d-none d-lg-inline d-xl-inline" v-else-if="(service.type == 'A' || service.type !== 'Q' || service.type !== 'Z')">
              <div class="row sitenumber">
                <h4 class="text-muted pb-3">Status:
                  <span  v-bind:class="'text-' + serviceUsageColour" v-if="getUsage && allowUtilisation"> 
                    {{ serviceUsageText}} <br class="pt-3 d-lg-inline d-xl-none"> <br class="pt-3 d-none d-xl-inline" v-if="serviceUsageText !== 'Available'"> - Current Usage: {{ atobUsage }}% <i class="menu-icon fa fa-arrow-right" style="color:rgba(255,99,132,1) !important"></i> / {{ btoaUsage  }}%<i class="menu-icon fa fa-arrow-left" style="color:rgba(132,99,255,1) !important"></i>
                  </span>
                  <span  v-bind:class="'text-' + serviceUsageColour" v-else-if="getUsage && !allowUtilisation"> 
                    {{ serviceUsageText}} <br class="pt-3 d-lg-inline d-xl-none"> <br class="pt-3 d-none d-xl-inline" v-if="serviceUsageText !== 'Available'"> - Current Usage: {{ atobUsage }}% <i class="menu-icon fa fa-arrow-right" style="color:rgba(255,99,132,1) !important"></i> / {{ btoaUsage  }}%<i class="menu-icon fa fa-arrow-left" style="color:rgba(132,99,255,1) !important"></i>
                  </span> 
                  <span class="text-luminous pb-2" v-else-if="statusCheck() && service.status == 0">
                  </span>
                  <span class="text-success pb-2" v-else>
                    Available
                  </span>
                </h4>
              </div> 
              <div class="row sitename text-luminous" v-if= "statusCheck() && service.status == 0"> <!--Check if service.status exists first for VERNet users as Customers don't see disabled services-->
              Disabled
              </div>
              <div  class="row sitename" v-else-if="!trafficLoadComplete"> <!--Customers don't see service status. if no events found, assume active-->
 <!--Customers experience a usage check for if service is nearing/at capacity-->
                  <button @click.prevent="getData" class="btn btn-sm btn-success" v-if="!trafficLoading">Show Usage Graph</button>
                  <button class="btn btn-sm btn-success" disabled v-else>Checking...</button>
              </div>
              <div  class="row sitename " v-else-if="trafficLoadComplete"> <!--Customers don't see service status. if no events found, assume active-->
                   <!--Customers experience a usage check for if service is nearing/at capacity-->
                   
                    <div v-if="trafficLoading">Loading Graph</div>
                    
                    <line-chart v-else-if="trafficLoadComplete && TrafficChartData.datasets.length > 0" class=""
                            id="trafficChart"
                            ref="trafficChart"
                            :chart-data="TrafficChartData"
                            :options="trafficChartOptions"
                            :styles="{width: '100%', height: '100px', position: 'relative', paddingLeft: 0}"
                            order-md="1"
                            order="0"
                    />
                     <div v-else-if="trafficLoadComplete && TrafficChartData.datasets.length == 0 && serviceUsageText == 'Available'">Traffic Data is not available at this time</div>
              </div>
              <div class="row sitename text-planning" v-else-if="!getUsage && allowUtilisation && (service.type !== 'A'|| service.type !== 'Z')">
                  <button @click.prevent="checkUsage" class="btn btn-sm btn-success" v-if="!isChecking">Check Usage</button>
                  <button @click.prevent="checkUsage" class="btn btn-sm btn-success" disabled v-else>Checking...</button>
              </div>
              <div class="row sitename text-planning" v-else>
              </div>
            </div>
          </div>
        </div>

</template>



<script>
import LineChart from '@/components/charts/chartjs/lineChart'
import Vue from "vue";
  const SERVICE_UTILISATION_REQUEST = "SERVICE_UTILISATION_REQUEST";
  const SERVICE_TRAFFICHISTORY_REQUEST = "SERVICE_TRAFFICHISTORY_REQUEST"

    export default {
        name: 'serviceComponent',
        components:
        {
          LineChart,
        },
        props: {
          serviceID: String,
          showColour: Boolean,
          loadUtilisation: {
            type: Boolean,
            default: false
          },
          allowUtilisation: {
            //Describes whether a user is allowed to request the utilization of a service manually.
            type: Boolean,
            default: false
          }
        }, 
        computed:{
          service(){
            try {
              return this.$store.getters.getService(this.serviceID);
            } 
            catch (error){
              return this.items;
            }
          },
          servicesLoaded(){
            return this.$store.getters.isServicesListLoaded
          },
          activeCheck(){
            if(this.service && Object.keys(this.service).includes("status")){
              if(this.service.status == 0){
                return "inactiveElement"
              } else{
                return "activeElement"
              }
            } else {
              return "activeElement"
            }
          },
          serviceUsageColour(){
            if(this.atobUsage > 80 || this.btoaUsage > 80){ //Above usage threshold, return red
              return "danger"
            } else{ //Normal utilization, return green
              return "success"
            }
          },
          serviceUsageText(){
            if(this.atobUsage > 85 || this.btoaUsage > 85){
              return "At Capacity"
            } else if(this.atobUsage > 80 || this.btoaUsage > 80){
              return "Nearing Capacity"
            } else{
              return "Available"
            }
          }
        },
        data () {
          return {
            serviceStatus: {
              state: 0,
              events: []
            },
            atobUsage: 0,
            btoaUsage: 0,
            isChecking: false,
            getUsage: false,
            trafficLoadComplete: false,
            trafficLoading: false,
            displayTrafficChart: false,
            TrafficChartData: {
              //labels: [],
              datasets: []
            },
            trafficChartOptions: {
              responsive: true,
              scales: {
                xAxes: [{
                  type: 'time',
                }]
              }
            },
          }
        },
        beforeMount(){
          if(this.statusCheck()){
            if(this.service.status == 0){
              let disabledStatus = {
                state: 0,
                events: []
              }
              this.serviceStatus = disabledStatus
            } else {
              this.serviceStatus = this.$store.getters.getServiceStatus(this.serviceID)
            }
          } else {
            this.serviceStatus = this.$store.getters.getServiceStatus(this.serviceID)
            if (this.loadUtilisation) {
                this.checkUsage()
            }
          }
        },
        methods:{
          servicetype(theType) {
            return this.$serviceTypes.find(service => service.letter === theType);
          },
          validSite(siteid){
            let testSite = this.$store.getters.getSite(siteid)

            if(testSite){
              return true
            } else {
              return false
            }

          },
          serviceDescription(){
           if(this.service && Object.keys(this.service).includes('speed')){
              return this.$store.getters.getServiceDescription(this.service.type, this.service.speed)
           } else {
            return ''
           }
          },
          statusCheck(){ //Check if service object has "status" in it
            return Object.keys(this.service).includes("status")
          },
          getData(){
            this.checkUsage()
            this.loadTrafficChart()
          },
          checkUsage(){
            if(this.service.type !== "A" && this.service.status !== 0){ //Generate the average utilization for the past hour
              let payload = {
                serviceid: this.serviceID,
                timespan: 1
              }
              this.isChecking = true
              this.$store.dispatch(SERVICE_UTILISATION_REQUEST, payload)
              .then(resp => {
                  let servicePayload = resp.payload
                  if(servicePayload && Object.keys(servicePayload).includes("atob") && servicePayload.atob !== null){   
                    this.atobUsage = Math.round(servicePayload.atob.reduce((a, b) => a + b.percentage, 0) / servicePayload.atob.length)
                  }
                  if(servicePayload && Object.keys(servicePayload).includes("btoa")&& servicePayload.btoa !== null){ 
                    this.btoaUsage = Math.round(servicePayload.btoa.reduce((b, a) => b + a.percentage, 0) / servicePayload.btoa.length)     
                  }
                  this.isChecking = false
                  this.getUsage = true
                }).catch(() => {
                  this.atobUsage = 0
                  this.btoaUsage = 0
                  this.isChecking = false
                  this.getUsage = true
              });
            } else { //No Traffic Data
              //If unmanaged, set usage to 0
              this.atobUsage = 0
              this.btoaUsage = 0
              this.isChecking = false
              this.getUsage = true
            }
          },
          loadTrafficChart() {
            this.TrafficChartData ={
              datasets: []
            }
            this.trafficChartOptions = {
              responsive: true,
              scales: {
                xAxes: [{
                  type: 'time',
                }]
              }
            }
            this.trafficLoadComplete = false
            this.trafficLoading = true
            this.$store.commit('suppressLoading', 'servicetraffichistory' + this.service.serviceid)
            this.$store.dispatch(SERVICE_TRAFFICHISTORY_REQUEST, {
              'serviceID': this.service.serviceid,
              'charttimespan': 6
            })
                .then(resp => {
                  this.$store.commit('unsuppressLoading', 'servicetraffichistory' + this.service.serviceid)
                  this.trafficLoading = false
                  let tempDatasets = []
                  if(resp.payload !== null) {

                    this.displayTrafficChart = true

                    if (resp.payload.atob) {

                      resp.payload.atob.forEach(function (obj) {
                        obj.y = Math.round(obj.value / 1024 / 1024)
                        delete obj.value;
                      });
                      resp.payload.atob.forEach(function (obj) {
                        obj.t = (obj.datetime * 1000);
                        delete obj.datetime;
                      });
                      //tempDatasets = []
                      tempDatasets.push({
                        label:  this.service.aendsitenumber + " -> " + this.service.bendsitenumber,
                        borderColor: [
                          'rgba(255,99,132,1)'
                        ],
                        borderWidth: 1,
                        fill: true,
                        backgroundColor: 'rgba(255,99,132,0.05)',
                        data: resp.payload.atob
                      })

                      this.TrafficChartData = {datasets: tempDatasets}
                      this.trafficChartOptions = {
                        scaleShowLabels: false,
                        responsive: true,
                        maintainAspectRatio: false,
                        tooltips: {
                          enabled: false,
                          mode: 'single',
                          callbacks: {
                            label: function (tooltipItems) {
                              return tooltipItems.yLabel + ' Mb/s'
                            },
                            labelColor: function(tooltipItems){
                              if(tooltipItems.datasetIndex == 0){
                                return {
                                  borderColor: 'rgba(255,99,132)',
                                  backgroundColor: 'rgba(255,99,132)',
                                  borderWidth: 0,
                                  borderRadius: 0,
                                }
                              } else {
                                return {
                                  borderColor: 'rgba(132,99,255)',
                                  backgroundColor: 'rgba(132,99,255)',
                                  borderWidth: 0,
                                  borderRadius: 0,
                                }
                              }
                            }
                          }
                        },
                        title: {
                          text: "Traffic History - Last 6 hours",
                          //  text: "Test",
                          display: false
                        },
                        legend: {
                          position: "right",
                          display: true
                        },
                        scales: {
                          xAxes: [{
                            type: 'time',
                            ticks: {
                              autoSkip: false,
                              maxRotation: 0,
                              major: {
                                enabled: true
                              },
                              // color: function(context) {
                              //   return context.tick && context.tick.major ? '#FF0000' : 'rgba(0,0,0,0.1)';
                              // },
                              font: function(context) {
                                if (context.tick && context.tick.major) {
                                  return {
                                    weight: 'bold',
                                  };
                                }
                              }
                            }
                          }],
                          yAxes: [{
                            ticks:{
                              display: false
                            },
                            scaleLabel: {
                              display: false,
                              labelString: '(Mb/s)'
                            }
                          }]
                        }
                      }
                      this.trafficLoadComplete = true

                    }
                    if (resp.payload.btoa) {
                      resp.payload.btoa.forEach(function (obj) {
                        obj.y = Math.round(obj.value / 1024 / 1024)
                        delete obj.value;
                      });
                      resp.payload.btoa.forEach(function (obj) {
                        obj.t = (obj.datetime * 1000);
                        delete obj.datetime;
                      });
                      tempDatasets.push({
                        label:   this.service.bendsitenumber + " -> " + this.service.aendsitenumber,
                        borderColor: [
                          'rgba(132,99,255,1)'
                        ],
                        borderWidth: 1,
                        fill: true,
                        backgroundColor: 'rgba(132,99,255,0.1)',
                        data: resp.payload.btoa
                      })
                      this.TrafficChartData = {datasets: tempDatasets}
                      this.trafficChartOptions = {
                        scaleShowLabels: false,
                        responsive: true,
                        maintainAspectRatio: false,
                        tooltips: {
                          enabled: false,
                          mode: 'single',
                          callbacks: {
                            label: function (tooltipItems) {
                              return tooltipItems.yLabel + ' Mb/s'
                            },
                            labelColor: function(tooltipItems){
                              if(tooltipItems.datasetIndex == 0){
                                return {
                                  borderColor: 'rgba(255,99,132)',
                                  backgroundColor: 'rgba(255,99,132)',
                                  borderWidth: 0,
                                  borderRadius: 0,
                                }
                              } else {
                                return {
                                  borderColor: 'rgba(132,99,255)',
                                  backgroundColor: 'rgba(132,99,255)',
                                  borderWidth: 0,
                                  borderRadius: 0,
                                }
                              }
                            }
                          }
                        },
                        title: {
                          text: "Traffic History - Last " + (this.chartTimeSpan > 24 ? 24 * this.ChartTimeSpan + " Days" : this.chartTimespan + " Hours"),
                          display: false
                        },
                        legend: {
                          position: "right",
                          display: true
                        },
                        scales: {
                          xAxes: [{
                            type: 'time',
                            ticks: {
                              autoSkip: false,
                              maxRotation: 0,
                              major: {
                                enabled: true
                              },
                              // color: function(context) {
                              //   return context.tick && context.tick.major ? '#FF0000' : 'rgba(0,0,0,0.1)';
                              // },
                              font: function(context) {
                                if (context.tick && context.tick.major) {
                                  return {
                                    weight: 'bold',
                                  };
                                }
                              }
                            }
                          }],
                          yAxes: [{
                            ticks:{
                              display: false
                            },
                            scaleLabel: {
                              display: false,
                              labelString: '(Mb/s)'
                            }
                          }]
                        }
                      }
                      this.trafficLoadComplete = true
                    }
                  }
                  this.trafficLoadComplete = true
                })
                .catch((resp) => {
                  this.trafficLoading = false
                  this.$store.commit('unsuppressLoading', 'servicetraffichistory' + this.$route.params.serviceid)
                  Vue.prototype.$snotify.warning((resp.message ? resp.message : "An error occurred retrieving service traffic history"), {
                    timeout: 2000,
                    showProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                  });
                });
          },
        }
   }
</script>